import 'semantic-ui-less/definitions/elements/input.less';import _default from './Input';
export { _default as default };